/**
 * Utilitaires de dates (affichage relatif + formatage)
 * Réutilisés dans la liste Clients (dates de publication, inscriptions…).
 */

// Convertit un Timestamp Firestore / Date / string en objet Date (ou null)
export const toDateValue = (value) => {
  if (!value) return null;
  try {
    if (typeof value.toDate === 'function') return value.toDate();
    if (value.seconds) return new Date(value.seconds * 1000);
    if (value instanceof Date) return value;
    if (typeof value === 'string') return new Date(value);
    return null;
  } catch (error) {
    console.warn('relativeTime: valeur de date invalide', value, error);
    return null;
  }
};

/**
 * Formate une date en valeur relative (« à l'instant », « il y a 5 min »,
 * « il y a 3 h », « il y a 12 j ») puis en date courte au-delà d'un mois.
 * @param {*} value - Timestamp Firestore, Date, string ISO ou null
 * @returns {string}
 */
export const formatRelativeDate = (value) => {
  const date = toDateValue(value);
  if (!date) return 'N/A';

  const diffMs = Date.now() - date.getTime();
  if (diffMs < -60000) return date.toLocaleDateString('fr-FR'); // date future → date simple

  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return "à l'instant";
  if (minutes < 60) return `il y a ${minutes} min`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `il y a ${hours} h`;

  const days = Math.floor(hours / 24);
  if (days < 31) return `il y a ${days} j`;

  return date.toLocaleDateString('fr-FR');
};

/**
 * Formate une date courte (jj/mm/aaaa) pour les tableaux.
 * @param {*} value - Timestamp Firestore, Date, string ISO ou null
 * @returns {string}
 */
export const formatShortDate = (value) => {
  const date = toDateValue(value);
  if (!date) return 'N/A';
  return date.toLocaleDateString('fr-FR');
};
